export const MAX_RATING_COUNT = 5;
export const STAR_RATING_FILLED_SIZE = '32px';

export const TEXT = {
  HEADING: 'Rating & Reviews',
  USEFUL_REVIEW: 'Most Helpful Review',
  VIEW_ALL: 'Read all Reviews',
  SHOW_REVIEWS: 'all-reviews',
  RATINGS: 'Ratings',
  REVIEWS: 'Reviews',
};
